import React from 'react'
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import * as changePage from '../redux/actions/change-page'
import * as loadContent from '../redux/actions/load-content'
import * as imageLoad from '../redux/actions/image-load'
import Page from '../components/global/Page'

class PageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.props.actions.loadContent();
  }

  render() {
    return (
      <Page
        changePage={this.props.actions.changePage}
        page={this.props.children}
        selectedPage={this.props.selectedPage}
        content={this.props.content}
        imagesLoaded={this.props.imagesLoaded}
        imageLoad={this.props.actions.imageLoad}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.page,
    imagesLoaded: state.imageStatus.imagesLoaded,
    selectedPage: state.page
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(Object.assign({}, changePage, loadContent, imageLoad), dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageContainer)



// WEBPACK FOOTER //
// ./src/containers/PageContainer.js